import React, { Component, Fragment } from 'react'

class WrapperRelatedTables extends Component {
	state = {}

	handleRowSelect = (tableState, rowInfo) => {
		// Get some data from server
		// ...
		// const relatedData = dataFromServer
		const relatedData = [rowInfo.original]

		this.setState({ relatedData: relatedData, parentData: rowInfo.original })
	}

	render({ children } = this.props) {
		return(
			<Fragment>
				{children(this.handleRowSelect, this.state.relatedData, this.state.parentData)}
			</Fragment>
		)
	}
}

export default WrapperRelatedTables
